module.exports = __webpack_public_path__ + "img/04_kii_20.f876eb91.jpg";